import React from 'react';
import './App.css';
import { Route, Routes } from "react-router-dom"
import Header from './Components/Header';
import Blog from './Components/Blog';
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Home from './Components/Home';
import Footer from './Components/Footer';


function App() {
  const name = "Steven Musembi";
  const title = "Front-End Developer";

  
  return (
    <>
   <Header  name={name} title={title}/>

   <Routes>
   <Route path='/' element={<Home />} />
   <Route path='projects' element={<Projects />} />
   <Route path='contact' element={<Contact />} />
   <Route path='blog' element={<Blog />} />
   </Routes>
   <Footer />
   </>
  );
}

export default App;
